/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  Box, Grid, makeStyles,
} from '@material-ui/core';

import { GetCourseByUser, GetTopicById } from '../../services/courses';
import { setAnalytics } from '../../utils';
import ReturnButton from '../General/ReturnButton';

import ContainerPracticalCaseSection from './PracticalCase/ContainerPracticalCaseSection';
import PracticalCard from './PracticalCase/PracticalCard';
import ContainerText from './Text/ContainerText';
import ContainerVideo from './Video/ContainerVideo';
import EvaluationCard from './EvaluationCard';
import Resources from './Resources';
import SkeletonLesson from './SkeletonLesson';
import SummaryLessons from './SummaryLessons';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      backgroundColor: theme.palette.background.primary,
      borderRadius: '10px',
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.background.secondary,
      borderRadius: '10px',
    },
  },
  container: {
    padding: theme.spacing(2, 5),
  },
  containerButton: {
    margin: theme.spacing(0, 0, 2, 0),
  },
  principalComponentContainer: {
    padding: theme.spacing(0, 1, 0, 0),
  },
  secondComponentContainer: {
    padding: theme.spacing(0, 0, 0, 4),
  },
  containerSummary: {
    '&::-webkit-scrollbar': {
      backgroundColor: theme.palette.background.grey,
      borderRadius: '10px',
      width: 15,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#1A3758',
      borderRadius: '10px',
    },
  },
}));

function Lesson() {
  const location = useLocation();
  const { sub } = useSelector((store) => store.login);
  const classes = useStyles();

  const {
    topic, type, practical, course, title, lessonId,
  } = location.state;

  const [isLoading, setIsLoading] = useState(true);
  const [listLessons, setListLessons] = useState([]);
  const [listResources, setListResources] = useState([]);
  const [contain, setContain] = useState([]);
  const [practicalCase, setPracticalCase] = useState([]);
  const [quizz, setQuizz] = useState([]);

  const apiGetTopicAndLessonById = async () => {
    const courseByUser = await GetCourseByUser(sub, course);
    const topicById = await GetTopicById(topic);

    const topicSelected = courseByUser.data[0].topicsByUser.filter((e) => e.idTopic === topic);

    setPracticalCase(topicSelected[0].practicalCaseByUser);
    setQuizz(topicSelected[0].quizByUser);

    const orderLessons = topicSelected[0].lessonsByUser.sort((a, b) => a.createdAt - b.createdAt);
    const lessons = orderLessons.map((e) => {
      const {
        id, idTopic, idLesson, idUser, name, createdAt,
      } = e;
      const selectedLesson = topicById.data.lessons.filter((i) => i.id === idLesson)[0];
      return {
        id,
        idLesson,
        idTopic,
        idUser,
        name,
        createdAt,
        contains: selectedLesson.contains,
        resources: selectedLesson.resources,
      };
    });
    setListLessons(lessons);
    setListResources(lessons.find((e) => e.idLesson === lessonId)?.resources);
    setContain(lessons.filter((e) => e.idLesson === lessonId)[0]?.contains);
    setIsLoading(false);
  };

  const printContentDefault = () => {
    const contentVideo = contain.find((e) => e.type === 'video');
    const contentText = contain.find((e) => e.type === 'text');
    if (contentVideo === undefined) {
      return (
        <ContainerText data={contentText} />
      );
    }
    return (
      <ContainerVideo data={contentVideo} />
    );
  };

  const printContentVideo = () => (
    <ContainerVideo data={contain.filter((e) => e.title === title)[0]} />
  );

  const printContentText = () => (
    <ContainerText data={contain.filter((e) => e.title === title)[0]} />
  );

  useEffect(() => {
    apiGetTopicAndLessonById();
    if (location.pathname === '/lesson') {
      setAnalytics('Course', 'Check_InicioLeccion');
    }
  }, [location.state.title, location.state.lessonId]);

  return (
    <div>
      <Grid container className={classes.container}>
        <Grid className={classes.containerButton}>
          <ReturnButton />
        </Grid>
        <Grid container>
          {isLoading ? (
            <SkeletonLesson />
          ) : (
            <>
              <Grid item xs={8} className={classes.principalComponentContainer}>
                {type === undefined && practical === undefined
                  ? printContentDefault()
                  : null}
                {type === 'video' ? printContentVideo() : null}
                {type === 'pdf' || type === 'text' ? printContentText() : null}
                {practical !== undefined ? (
                  <ContainerPracticalCaseSection />
                ) : null}
              </Grid>
              <Grid item xs={4} className={classes.secondComponentContainer}>
                <Box
                  style={{
                    maxHeight: 550,
                    overflow: 'auto',
                  }}
                  className={classes.containerSummary}
                >
                  {listLessons.map((e) => (
                    <Box key={e.name}>
                      <SummaryLessons list={e} />
                    </Box>
                  ))}
                </Box>
                <Box>
                  {' '}
                  {quizz.length !== 0 ? <EvaluationCard quizz={quizz} /> : null}
                  {practicalCase.length !== 0 ? (
                    <PracticalCard practical={practicalCase} />
                  ) : null}
                </Box>
                <Resources list={listResources} />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default Lesson;
